export default {
    typography: {
        '*': {
            fontFamily: 'Hind'
        },
        'learnworlds-main-text':{
            fontFamily: 'Hind'
        },
        'learnworlds-heading':{
            fontFamily: 'Libre Baskerville'
        },
        'learnworlds-subheading':{
            fontFamily: 'Libre Baskerville'
        },
        'learnworlds-heading3':{
            fontFamily: 'Libre Baskerville'
        },
        'learnworlds-heading4':{
            fontFamily: 'Libre Baskerville'
        },
        'learnworlds-button':{
            fontFamily: 'Hind'
        },
        'learnworlds-input':{
            fontFamily: 'Hind'
        },
        'learnworlds-heading-large':{
            fontSize: 60,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-heading-normal': {
            fontSize: 50,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-heading-small': {
            fontSize: 40,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-subheading-large': {
            fontSize: 40,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-subheading-normal': {
            fontSize: 29,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-subheading-small': {
            fontSize: 25,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-heading3-large': {
            fontSize: 24,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-heading3-normal': {
            fontSize: 20,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-heading3-small': {
            fontSize: 18,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'none'
        },
        'learnworlds-heading4-large': {
            fontSize: 21,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-heading4-normal': {
            fontSize: 18,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-heading4-small': {
            fontSize: 14,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-main-text-huge': {
            fontSize: 80,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.6,
            textTransform: 'none'
        },
        'learnworlds-main-text-very-large': {
            fontSize: 60,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.6,
            textTransform: 'none'
        },
        'learnworlds-main-text-large': {
            fontSize: 22,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.6,
            textTransform: 'none'
        },
        'learnworlds-main-text-normal': {
            fontSize: 19,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.6,
            textTransform: 'none'
        },
        'learnworlds-main-text-small': {
            fontSize: 17,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.6,
            textTransform: 'none'
        },
        'learnworlds-main-text-very-small': {
            fontSize: 15,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.6,
            textTransform: 'none'
        },
        'learnworlds-main-text-tiny': {
            fontSize: 12,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.6,
            textTransform: 'none'
        },
        'learnworlds-quote-text': {
            fontFamily: 'Hind',
            fontSize: 32,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.6,
            textTransform: 'none'
        },
        'learnworlds-overline-text': {
            fontFamily: 'Hind',
            fontSize: 12,
            fontWeight: 'bold',
            letterSpacing: 0.1,
            lineHeight: 1.6,
            textTransform: 'uppercase'
        }
    },
    input: {
        'learnworlds-button-large': {
            fontSize: 20,
            fontWeight: 'bold',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 23,
            paddingRight: 38,
            paddingBottom: 21,
            paddingLeft: 38
        },
        'learnworlds-button-normal': {
            fontSize: 18,
            fontWeight: 'bold',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 17,
            paddingRight: 28,
            paddingBottom: 15,
            paddingLeft: 28
        },
        'learnworlds-button-small': {
            fontSize: 14,
            fontWeight: 'bold',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 13,
            paddingRight: 14,
            paddingBottom: 11,
            paddingLeft: 14
        },
        'learnworlds-input-large': {
            fontSize: 20,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 23,
            paddingRight: 38,
            paddingBottom: 23,
            paddingLeft: 38
        },
        'learnworlds-input-normal': {
            fontSize: 18,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 17,
            paddingRight: 28,
            paddingBottom: 15,
            paddingLeft: 28
        },
        'learnworlds-input-small': {
            fontSize: 13,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 13,
            paddingRight: 14,
            paddingBottom: 11,
            paddingLeft: 14
        },        
    },
    colors: {
        'lw-brand-bg': {
            color: 'rgb(0, 188, 212)',
            textType: 'light',
            lessVars: {
                'brand-color': 'rgb(0, 188, 212)',
                'text-over-brandbg-color' : '@light-text-color'
            }
        },
        'lw-dark-bg': {
            color: 'rgb(0, 105, 119)',
            textType: 'light',
            lessVars: {
                'dark-bg-color': 'rgb(0, 105, 119)',
                'text-over-darkbg-color' : '@light-text-color'
            }
        },
        'lw-light-bg': {
            color: 'rgb(249, 250, 253)',
            textType: 'dark',
            lessVars: {
                'light-bg-color': 'rgb(249, 250, 253)',
                'text-over-lightbg-color' : '@dark-text-color'
            }
        },
        'lw-brand-accent1-bg': {
            color: 'rgb(0, 188, 212)',
            textType: 'light',
            lessVars: {
                'brand-accent1-color': 'rgb(0, 188, 212)',
                'text-over-brandaccent1bg-color' : '@light-text-color'
            }
        },
        'lw-brand-accent2-bg': {
            color: 'rgb(0, 188, 212)',
            textType: 'light',
            lessVars: {
                'brand-accent2-color': 'rgb(0, 188, 212)',
                'text-over-brandaccent2bg-color' : '@light-text-color'
            }
        },
        'lw-body-bg': {
            color: 'white',
            textType: 'dark',
            lessVars: {
                'body-bg-color': 'white',
                'text-over-bodybg-color' : '@dark-text-color'
            }
        },
        'lw-light-text': {
            color: '#ffffff',
            lessVars: {
                'lw-light-text': '#ffffff',
            }
        },
        'lw-dark-text': {
            color: '#262626',
            lessVars: {
                'lw-dark-text': '#262626',
            }
        },
        'lw-link-text': {
            color: 'red',            
            lessVars: {
                'link-text-color': 'red',
            }
        }
    }
}